module.exports = __webpack_public_path__ + "static/media/21ECLAC44.1e451d2d.jpg";